import { useContext } from 'react';

import { NotificationContext } from '../NotificationContext';

/** Return state and method for displaying notifications */
export const useNotifications = () => useContext(NotificationContext);
